var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIconLocation = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "M32.07 35.082H4.302a3.59 3.59 0 0 1-3.579-3.579V3.735A3.59 3.59 0 0 1 4.303.156H32.07a3.59 3.59 0 0 1 3.58 3.58v27.767a3.59 3.59 0 0 1-3.58 3.58z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#666",
    strokeMiterlimit: 20,
    d: "M11.754 16.362a5.91 5.91 0 0 1-.396-2.112c0-3.499 3.057-6.336 6.829-6.336s6.83 2.837 6.83 6.336c0 .742-.145 1.451-.398 2.112v.001a6.105 6.105 0 0 1-.5 1.017l-5.932 9.944v0l-6.433-10.962v0z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#666",
    strokeMiterlimit: 20,
    d: "M21.585 14.024a3.397 3.397 0 1 1-6.797 0 3.397 3.397 0 0 1 6.797 0z"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconLocation, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_location.e76045b5.svg";
export { ForwardRef as ReactComponent };